import { DeleteAgent } from './DeleteAgent'
import { EditAddAgent } from './EditAddAgent'
import { ReInviteAgent } from './ReInviteAgent'
import { ResetAgentPassword } from './ResetAgentPassword'
import { AgentActionsTypes, CommonPropsAgent } from './types'

export const modalsActions: Record<
  AgentActionsTypes,
  React.FC<CommonPropsAgent>
> = {
  edit: EditAddAgent,
  delete: DeleteAgent,
  reInvite: ReInviteAgent,
  resetPassword: ResetAgentPassword
}
